const React = require('react');
const T = require('prop-types');
const { default: Styled } = require('styled-components');
const BottomButtonContainer = require('components/BottomButtonContainer');

const useForm = require('hooks/useForm');
const EditGroupPageFormConfig = require('./formConfig');

const { useMemo, useRef, useState } = React;

const internals = {};

module.exports = function EditGroupPage(props) {

    const {
        schoolRoles,
        schoolName,
        isCreate,
        isCompany,
        isCommunity,
        isSchoolOnline,
        schoolEnableReactions,
        schoolEnableGroupGifs,
        groupDetails,
        onSubmit
    } = props;

    const { Wrapper } = internals;
    const formId = 'create-group-form';

    const isTeamsApp = useRef(process.env.APP_FLAVOUR === 'teams');
    const [isAnnouncement, setIsAnnouncement] = useState(false);
    const formConfig = useMemo(() => EditGroupPageFormConfig.buildFormConfig({
        groupDetails,
        isAnnouncement,
        isCompany,
        isCommunity,
        isCreate,
        isSchoolOnline,
        isTeamsApp: isTeamsApp.current,
        onAnnouncementChange: setIsAnnouncement,
        schoolEnableGroupGifs,
        schoolEnableReactions,
        schoolName,
        schoolRoles,
        formId,
        onSubmit
    }), [
        groupDetails,
        isAnnouncement,
        isCompany,
        isCommunity,
        isCreate,
        isSchoolOnline,
        schoolEnableGroupGifs,
        schoolEnableReactions,
        schoolName,
        schoolRoles,
        formId,
        onSubmit
    ]);

    const { Form } = useForm(formConfig);

    return (
        <BottomButtonContainer
            btnLabel={isCreate ? 'Create' : 'Save'}
            formId={formId}
        >
            <Wrapper>
                {Form}
            </Wrapper>
        </BottomButtonContainer>
    );
};

module.exports.propTypes = {
    schoolName: T.string,
    isCreate: T.bool,
    isCompany: T.bool,
    isCommunity: T.bool,
    isSchoolOnline: T.bool,
    schoolEnableReactions: T.bool,
    schoolEnableGroupGifs: T.bool,
    schoolRoles: T.array.isRequired,
    groupDetails: T.object,
    onSubmit: T.func.isRequired
};

internals.Wrapper = Styled.div`
    padding: 24px;

    @media (max-width: 600px) {
        padding: 0 18px;
    }
`;
